import React, { useMemo, useState } from 'react';
import { Pressable, Platform, View } from 'react-native';
import Text from '@/components/Typography/Text';
import Icon from '@/components/Icon';
import { BORDER_RADIUS } from '@/constants/config';
import { formatCount } from '@/utils/agent_catalog';

const SUPPORTS_HOVER = (() => {
  if (Platform.OS !== 'web' || typeof window === 'undefined' || !window.matchMedia) return false;
  try {
    return window.matchMedia('(hover: hover)').matches;
  } catch {
    return false;
  }
})();

export default function TopicTagListItem({ tag, colors, onPress }) {
  const [hovered, setHovered] = useState(false);
  const topicCount = tag?.stats?.topicCount ?? 0;
  const topicLabel = `${formatCount(topicCount)} ${topicCount === 1 ? 'topic' : 'topics'}`;

  const itemStyle = useMemo(() => ({
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    paddingVertical: 8,
    paddingHorizontal: 10,
    borderRadius: BORDER_RADIUS.small,
    borderWidth: 1,
    borderColor: colors.border_color_secondary,
    backgroundColor: hovered ? colors.solid_color_tertiary : colors.solid_color_block,
    ...(Platform.OS === 'web' ? { cursor: 'pointer' } : null),
  }), [colors, hovered]);

  return (
    <Pressable
      style={itemStyle}
      onPress={onPress}
      onHoverIn={SUPPORTS_HOVER ? () => setHovered(true) : undefined}
      onHoverOut={SUPPORTS_HOVER ? () => setHovered(false) : undefined}
      accessibilityRole="button"
    >
      <View style={{
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: 6,
        minWidth: 0,
      }}
      >
        <Text size="s" weight="medium" numberOfLines={1} style={{ flexShrink: 1 }}>
          {tag.name}
        </Text>
        {topicCount > 0 && (
          <>
            <Text size="s" color="tertiary" style={{ opacity: 0.45, fontSize: 12, lineHeight: 18 }}>·</Text>
            <Text size="s" color="tertiary" numberOfLines={1}>
              {topicLabel}
            </Text>
          </>
        )}
      </View>
      <Icon name="arrow-right" size={12} color={colors.text_color_tertiary} />
    </Pressable>
  );
}
